<template>
  <transition name="fade">
    <Modal v-if="showModal" @close="showModal = false" snug>
      <div class="text-center">
        <div class="w-20 mx-auto mb-4">
          <IconDelivery />
        </div>
        <h3 class="text-md mb-4">Thankyou for your order!</h3>
        <p class="mb-4 md:mb-8 text-sm">
          Yay, your order has been placed! You will receive a confirmation email
          very shortly. We will get straight onto processing your order and will
          have it delivered to you in the next few working days.
        </p>
        <div class="grid grid-cols-2 gap-x-4 gap-y-2">
          <button
            class="col-span-2 md:col-span-1 btn-soft px-2"
            @click="showModal = false"
          >
            Continue Shopping
          </button>
          <a
            class="col-span-2 md:col-span-1 btn-strong px-2"
            :href="`/shop/customer/order?number=${orderNumber}&success=true`"
            >View My Order</a
          >
        </div>
        <div class="mt-4 md:mt-6" v-if="orderHasTestPot">
          <button class="link underline max-w-xs focus:outline-none" @click="showTestPotQuestion = true" v-show="!showTestPotQuestion">Can we ask you ONE question about your test pot purchase?</button>
          <div id="hubspotForm" class="testpot-hs-form" v-show="showTestPotQuestion"></div>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
import Modal from "./Modal.vue";
import IconDelivery from "../../../templates/_includes/svg/icon-delivery.svg";
const queryString = require("query-string");

export default {
  name: "ModalOrderConfirmation",
  components: { Modal, IconDelivery },
  data() {
    return {
      showModal: false,
      orderNumber: null,
      orderHasTestPot: true,
      showTestPotQuestion: false,
    };
  },
  mounted() {
    const locationSearch = location.search;

    if (locationSearch) {
      const orderNumber = queryString.parse(locationSearch).orderConfirmation;
      const orderHasTestPot = queryString.parse(locationSearch).orderHasTestPot === 'yes';

      if (orderNumber) {
        this.showModal = true;
        this.orderNumber = orderNumber;
        this.orderHasTestPot = orderHasTestPot;
      }
    }

    // HubSpot Form
    if (this.orderHasTestPot) {
      const script = document.createElement("script");
      script.src="https://js.hsforms.net/forms/v2.js";
      document.body.appendChild(script);
      script.addEventListener("load", () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: "20489130",
            region: "na1",
            formId: "bf583341-86da-4215-acaa-eaee2161890e",
            target: "#hubspotForm",
          })
        }
      })
    }
  },
};
</script>